<template>
  <div class="matters">
    <section class="content-header">
      <h1>
        {{ $t('menu.matters') }}
        <div v-if="!loading" class="dt-buttons btn-group pull-right" id="matters-status-buttons">
          <button
            @click="setMattersStatus('open')"
            class="btn"
            v-bind:class="{ 'btn-primary active': mattersStatus === 'open', 'btn-default': mattersStatus !== 'open' }"
            type="button"
            id="open_matter_button"
            data-toggle="tooltip"
            :title="$t('general.open')"
          >
            <i class="fa fa-folder-open" aria-hidden="true"></i>
          </button>
          <button
            @click="setMattersStatus('close')"
            class="btn"
            v-bind:class="{ 'btn-primary active': mattersStatus === 'close', 'btn-default': mattersStatus !== 'close' }"
            type="button"
            id="archived_matter_button"
            data-toggle="tooltip"
            :title="$t('general.archived')"
          >
            <i class="fa fa-archive" aria-hidden="true"></i>
          </button>
        </div>
      </h1>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-body">
              <div v-if="loading">
                  {{ $t('general.loading') }}
              </div>
              <DataTable
                v-else
                :tableData="tableData"
                :tableConfiguration="{}"
                :tableColumns="[
                  { title: $t('matter.datatable.name'), data: 'name' },
                  { title: $t('matter.datatable.practiceArea'), data: 'practice_area.name' },
                  { title: $t('matter.datatable.currency'), data: 'currency' },
                  { title: $t('matter.datatable.manager'), data: 'manager.full_name' },
                  { title: $t('matter.datatable.creationDate'), data: 'creation_date', type: 'date', render: renderDate }
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DataTable from '../components/common/DataTable'
import MatterApi from '../api/matter'
import $ from 'jquery'

// noinspection JSUnusedGlobalSymbols
export default {
  data: () => {
    return {
      tableData: null,
      loading: true,
      mattersStatus: 'open'
    }
  },
  components: {
    DataTable
  },
  methods: {
    setMattersStatus (status) {
      this.mattersStatus = status
      MatterApi.getAllMatters(status)
        .then(matters => {
          this.tableData = matters
        })
    },
    renderDate (data, type, row, meta) {
      if (!(data instanceof Date)) {
        data = new Date(data)
      }

      if (type === 'display') {
        return this.$d(data, 'short')
      }

      return data
    }
  },
  mounted () {
    MatterApi.getAllMatters()
      .then(matters => {
        this.tableData = matters
        this.loading = false
        this.$nextTick(() => {
          $('#matters-status-buttons').appendTo('.datatable-custom-buttons')
          $('[data-toggle="tooltip"]').tooltip()
        })
      })
  }
}
</script>
